const getBaseUrl = () => {
  return location.origin.includes('localhost') ? 'https://staging.gillettefamilyfarms.com' : location.origin
}

export default getBaseUrl;